<template>
<div id="reporte_soluciona_cargos">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="library_books" title="IMPORTAR CARGOS" class="elevation-1 px-5 py-3">
          <br>

          <div class="contenedor-tab-reportes">
            <v-card-text>
              <v-card-title>
                <span class="headline"></span>
              </v-card-title>
              <v-form ref="form" lazy-validation>
                <v-container grid-list-md text-xs-center>
               
                  <v-row row wrap>
                    <v-col  cols="3" sm="3" md="3">
                                <v-autocomplete v-model="planta" label="Origen" :items="plantas" :hide-no-data="true" :item-text="getNombreClave" item-value="rfc"    :rules="[rules.required]">

                                </v-autocomplete>
                                    </v-col>
                    <v-col sm="3" md="3" lg="3">
                      <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                            :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                        </template>

                        <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                          <v-spacer />

                          <v-btn color="secondary" x-small @click="menu1 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col sm="3" md="3" lg="3">
                      <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                            :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]"></v-text-field>
                        </template>
                        <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                          <v-spacer />

                          <v-btn color="secondary" x-small @click="menu2 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>

                    </v-col>
                    <v-col sm="3" md="3" lg="3">
                            <v-btn color="success" @click="generar_reporte_sqs">
                        <v-icon>done</v-icon>IMPORTAR CARGOS
                      </v-btn>
                    </v-col>
                  </v-row>
                  <!-- <v-row no-row wrap>
                    <v-col cols="12" sm="3" lg="3" class="pa-0 ps-2 pt-1">
                      <v-autocomplete v-model="model.activo" :items="list_activos" :hide-no-data="true" item-text="text" item-value="id" :return-object="false" label="Activo Fijo" @change="getFracciones()">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" lg="4" class="pa-0 ps-2 pt-1">
                      <v-autocomplete v-model="model.fraccion" :items="fracciones" :hide-no-data="true" clearable :return-object="false" label="Seleccione una Fracción">
                      </v-autocomplete>
                    </v-col>
                  </v-row> -->
                </v-container>

              </v-form>
            </v-card-text>
          
            <v-card-text>
              <v-refresh-button :funcion="cargarReportes" />
              <v-client-table ref="vuetable" :data="datos.reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>

                <template slot="actions" slot-scope="props">
              
                  <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row._id)">
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                </template>
              </v-client-table>
            </v-card-text>
          </div>

        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.loading = false;
    this.tipo = 1;
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.usuario = this.$local_storage.get("id_usuario");
    // this.getFracciones();
    this.cargarReportes();
    this.cargarPlantas();
  },
  computed: {},
  data: () => ({
    plantas:[],
    planta:'',
    permisoEliminar: false,
  
    fracciones: [],
    fab: false,
    rfc: '',
    tipo: '',
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Datastage",
        disabled: true,
        to: ""
      },
      {
        text: "Importar Cargos",
        disabled: true,
        to: ""
      }
    ],
    datos: {
      reportes: []
    },
    columns_reportes: [ "fecha", "usuario", "rfc", "fecha_de",  "fecha_a",  "total", "actions"],
    options_reportes: {
      filterable: [ "fecha", "usuario", "rfc", "fecha_de",  "fecha_a",  "total"],
      sortable: [ "fecha", "usuario", "rfc", "fecha_de",  "fecha_a",  "total"],

      headings: {
        fecha: "Solicitado",
        usuario: "Usuario",
        fecha_de: "Fecha De",
        fecha_a: "Fecha A",
        rfc: "Origen",
        total: "Total Importados",
        actions: "Opciones"
      }
    },
    loading: false,
    show_loading: true,
   
    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
    },
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,

  }),
  methods: {
    getNombreClave: function(row) {
      return row.rfc + " - " + row.referencia;
    },
    cargarPlantas: async function () {

      let data = {
          cliente: this.$local_storage.get("id_cliente"),
      };
      await axios.post(this.$hostname + "catalogos/referencias/get_referencias/", data)
          .then(res => {
              if (typeof res.data !== "undefined") {
              
                  this.plantas =  res.data.filter(t => t.rfc != '' );
             
              }
      })
      .catch(err => {
          console.log();
      });
      },
    validaMes: function() {
      if (this.model.fecha_de != null && this.model.fecha_a != null && this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial.";
      //  if (Math.abs(diferencia) > 365)
        //  return "Periodo máximo de consulta 31 días. Favor de verificar.";
      }
      return true;
    },

    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },

 
    generar_reporte_sqs() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = {
              "rfc": this.planta,
              "rfc_destino":  this.$local_storage.get("rfc"),
              "fecha_de": this.model.fecha_de,
              "fecha_a": this.model.fecha_a,
              "usuario": this.$local_storage.get("email")
          };

        axios({
            method: "post",
            url: "https://apivucem.econnectpro.mx/vucem/importar_cargos/",
            data: data
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.cargarReportes();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    cargarReportes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
      };
      axios.post( "https://apivucem.econnectpro.mx/vucem/list_log_cargos/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportes = res.data;
           
            this.datos.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha) - new Date(a.fecha);
            });
            for (var k in this.datos.reportes) {
              this.datos.reportes[k].fecha = this.parseDate(this.datos.reportes[k].fecha);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el proceso, se eliminaran los pedimentos que se importaron?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id: idreporte,
          }
          axios.post( 'https://apivucem.econnectpro.mx/vucem/borrar_cargos_importados/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportes();
            });
        }
      });
    },

   
 
  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}

.elevation-1 .v-expansion-panel>>>.v-label.theme--light {
  color: black !important;
}

.elevation-1>>>div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control {
  margin-bottom: -35px;
}

.elevation-1>>>.v-input--has-state>div:nth-child(1)>div:nth-child(2) {
  margin-top: -10px;
}

.elevation-1>>>div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control div.v-input__slot label.v-label.theme--light {
  font-size: 10px !important;
}

.v-card__text>>>.columnadescripcion {
  white-space: normal !important;
  max-width: 300px !important;
}

.v-card__text>>>.columnaidentificadores {
  white-space: normal !important;
  max-width: 450px !important;
}
</style>
